import { Collapse } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { AppConfigsFormConfiguration, AppConfigsTab } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import { ApplicationConfigurationsTab } from "./ApplicationConfigurationsTab";

export interface ApplicationConfigurationsFormProps {
    appConfigsFormData: AppConfigsFormConfiguration;
}

export const ApplicationConfigurationsForm: FC<ApplicationConfigurationsFormProps> = ({ appConfigsFormData }) => {
    const { Panel } = Collapse;
    const { t } = useTranslation();

    const renderPanels = (data: AppConfigsTab[]) => {
        return data?.map((dataItem) => {
            const fields = dataItem.configFields;
            return (
                <Collapse key={`${dataItem.key}-Collapse`}>
                    <Panel header={t(`form.tab.${dataItem.header}`)} key={`${dataItem.key}-Panel`}>
                        {fields && <ApplicationConfigurationsTab appConfigsTab={dataItem} />}
                    </Panel>
                </Collapse>
            );
        });
    };

    return <Collapse>{renderPanels(appConfigsFormData.configTabs || [])}</Collapse>;
};
